import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Container, Draggable } from "react-smooth-dnd";

import { connect } from 'react-redux';
// import arrayMove from "array-move";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import * as CalendarSaga from './Saga/Calendar';



import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent
  } from "@dnd-kit/core";
  import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy
  } from "@dnd-kit/sortable";
  import SortableItem from "./SortableItem";
//   import { Item } from "./types";





const SortableList = (props: any) => {

      const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
          coordinateGetter: sortableKeyboardCoordinates
        })
      );

      const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;
    
        if (!over) {
          return;
        }
    
        if (active.id !== over.id) {

          const oldIndex = props.calendar_group_user_list.findIndex((v:any) => v.id === active.id);
          const newIndex = props.calendar_group_user_list.findIndex((v:any) => v.id === over.id);
          const newArray = arrayMove(props.calendar_group_user_list, oldIndex, newIndex)
          props.change_calendar_group_user_list(newArray)
        }
      };




    return (

    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={props.calendar_group_user_list} strategy={verticalListSortingStrategy}>
        <div
          style={{
            border: '1px solid #ccc', // 外枠
            width: 250,              // 必要に応じて幅指定
            height: 455,          // 枠の高さ
            display: 'flex',
            flexDirection: 'column',
            padding:0,
            marginTop:20,
          }}
        >


          <List
            style={{
              overflowY: 'auto',     // スクロールは内部のみ
              flex: 1,               // 枠いっぱいに伸ばす
              padding: 0,
              overflowX: 'hidden',
            }}
          >
            {props.calendar_group_user_list.map((item:any) => (
              <SortableItem key={item.id} item={item} />
            ))}
          </List>

        </div>

      </SortableContext>
    </DndContext>

    );
};



const mapStateToProps = (state: any) => {
    return {
        users_select: state.masterReducer.users_select,

        user_details: state.masterReducer.user_details,



        calendar_group_user_list: state.calendar.calendar_group_user_list,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {

        change_calendar_group_user_list(state: any) {
            dispatch(CalendarSaga.change_calendar_group_user_list(state))
        },


    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SortableList);

